import React from 'react';
import { Draggable } from '@hello-pangea/dnd';
import { Grip } from 'lucide-react';

export function DraggableComponent({ field, index, onAdd }) {
  const Icon = field.icon;
  
  return (
    <Draggable draggableId={field.type} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          onClick={() => onAdd({ ...field, id: crypto.randomUUID() })}
          className={`
            group bg-card p-3 rounded-md border border-brand/20
            ${snapshot.isDragging ? 'shadow-lg ring-2 ring-[#003423] ring-offset-2' : 'shadow-sm'}
            hover:shadow-md hover:border-brand/40 transition-all duration-200
            cursor-pointer
          `}
        >
          <div className="flex items-center gap-2">
            {/* <Grip className="w-4 h-4 text-foreground group-hover:text-foreground transition-colors" /> */}
            {Icon && <Icon className="w-4 h-4 text-foreground group-hover:text-foreground transition-colors" />}
            <span className="text-foreground font-medium">{field.label}</span>
          </div>
        </div>
      )}
    </Draggable>
  );
} 